import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class DialogExport extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      isLoading: false
    }
  }

  static get propTypes () {
    return {
      title: PropTypes.string.isRequired,
      numberOfRecords: PropTypes.number.isRequired,
      unitsTitle: PropTypes.string,
      actions: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func,
        buttonText: PropTypes.string,
        labelText: PropTypes.string
      })).isRequired
    }
  }

  static get defaultProps () {
    return {
      numberOfRecords: 0,
      actions: [],
      unitsTitle: 'common.list.rows'
    }
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })
  }

  setIsLoading (isLoading) {
    this.setState({ isLoading })
  }

  render () {
    const { numberOfRecords, title, actions, unitsTitle } = this.props
    const { active, isLoading } = this.state

    const colClassName = classnames('actionboard-col2', {
      disabled: isLoading
    })

    return (
      <Dialog active={active} onClose={() => this.hide()} modal>
        <div className='dialog-actionboard'>
          <div className='actionboard-section'>
            <div className='actionboard-row'>
              <div className='actionboard-col'>
                <div className='title'>
                  <IntlMessage ident={title} />
                </div>
                <div className='msg'>
                  {numberOfRecords || ''} <IntlMessage ident={unitsTitle} />
                </div>
              </div>
            </div>
          </div>
          <div className='actionboard-footer'>
            <div className='actionboard-row'>
              {actions.map(({ buttonText, labelText, onClick }, index) => {
                return (
                  <div className={colClassName} key={index}>
                    <div className='action-btn' onClick={onClick}>
                      <Button title={buttonText} className='button_dialog' />
                      <span className='label'>
                        <IntlMessage ident={labelText} />
                      </span>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Dialog>
    )
  }
}

export default DialogExport
